module.exports = __webpack_public_path__ + "static/certificate4-d1a43850122cec788383c50890799552.pdf";